import falyerImg from '../images/poligrafiya/flayer.png';
import bukletImg from '../images/poligrafiya/buklet.png';
import vizitkaImg from '../images/poligrafiya/vizitka.png';
import paketImg from '../images/poligrafiya/paket.png';
import kalendarImg from '../images/poligrafiya/kalendar.png';
import faylImg from '../images/poligrafiya/fayl.png';
import lifletImg from '../images/poligrafiya/liflet.png';
import kundalikImg from '../images/poligrafiya/kundalik.png';

const poligrafiya = [
  {
    title: 'Flayer',
    subtitle: '',
    text: 'Reklama flayerlari mahsulot yoki xizmatlaringiz ommalashishida qat’iy tarzda mijozlar e’tiborini jalb etish va buning uchun ko‘p xarajat talab etilmasligi bilan ahamiyatlidir. Flayerlar e’lon qilinayotgan mahsulot yoki xizmatlar to‘g‘risida batafsil ma’lumot berishi bilan ham o‘ziga xos xarakterga ega. Bu esa biznesingiz rivojida mijozlar ko‘lamini kengaytirish, mahsulot yoki xizmatlar savdo ko‘lamini oshirish hamda yuqori daromad olishda muhim ahamiyat kasb etadi.',
    image: falyerImg,
    url: '/product/flayer',
  },
  {
    title: 'Buklet',
    subtitle: '',
    text: 'Bukletlar reklama qilinayotgan mahsulot, xizmatlar yoki tadbirlar ommalashishida muhim rolga ega va hamyonbop reklama vositasidir. Ulardan har xil turdagi aksiyalar, ko‘rgazmalar va  keng turdagi namoyishlarning taqdimoti uchun foydalaniladi. Bukletlarning  vazifasi takliif qilinayotgan mahsulot yoki xizmatlar to‘g‘risida iste’molchlarga batafsil ma’lumot yetkazishdir.',
    image: bukletImg,
    url: '/product/buklet',
  },
  {
    title: 'Vizitka',
    subtitle: '',
    text: 'Tashrif qog‘ozlari — bular xizmat ko‘rsatuvchi shaxs yoki tadbirkorlar haqida dastlabki ma’lumotlarni yetkazuvchi vositadir. Hamkorlar yoki mijozlar bilan o‘zaro ma’lumot almashinuvida tashrif qog‘ozlari o‘ziga xos ahamiyatga ega.',
    image: vizitkaImg,
    url: '/product/vizitka',
  },
  {
    title: 'Paket',
    subtitle: '',
    text: 'Tovar belgisi yoki kompaniya brendi chop etilgan paketlar muhim reklama vositalaridir. Bu orqali siz mijozlar ongida yaxshi taassurot qoldirish va doimiy tarzda ular yodida saqlanish hamda ular iste’mol burchagining bir bo‘lagiga aylanishingiz mumkin.',
    image: paketImg,
    url: '/product/paket',
  },
  {
    title: 'Kalendar',
    subtitle: '',
    text: 'Kalendar qadimdan ofis, uy va boshqa turar hamda noturar joylarni bezovchi vositalardan  biridir. Ularga o‘z reklamangizni chop etish orqali Siz o‘z biznesingiz va xizmatlaringiz ommalashishida ulkan muvaffaqiyatlarga erishishingiz',
    image: kalendarImg,
    url: '/product/kalendar',
  },
  {
    title: 'Fayl',
    subtitle: '',
    text: 'Reklama vositalarining ushbu usuli aniq amaliy qo‘llanmaga ega bo‘lib, undan korxona va tashkilotlarning har bir bo‘limida foydalaniladi. Bunday fayl papkalaridan, odatda, kompaniya va tashkilotlar hamda boshqa turdagi tuzilmalar o‘z brendlari yoki Tovar  belgilarini targ‘ib etishda keng foydalanadilar va ayni damda bu reklamaning eng arzon va  samarali usullaridan biridir.',
    image: faylImg,
    url: '/product/fayl',
  },
  {
    title: 'Liflet',
    subtitle: '',
    text: 'Lifletlar — tovar va xizmatlar reklamasida o‘ziga xos o‘rin tutuvchi reklama vositalaridir. Ulardan kichik kompaniyalar yoki katta korporatsiyalar o‘z mahsulotlari to‘g‘risidagi ma’lumotlarni batafsil yoritishda foydalaniladi. Lifletlar stomatologik klinikalar,  yoqilg‘I quyish shahobchalari, banklar, pulli klinikalar va shu kabi tashkilotlar o‘z  mahsulot va xizmatlarini reklama qilishda muhim reklama vositalaridir.',
    image: lifletImg,
    url: '/product/liflet',
  },
  {
    title: 'Kundalik',
    subtitle: '',
    text: 'Hamkasblaringiz, yaqinlar yoki yaqin hamkorlaringiz uchun unutilmas sovg‘a bo‘lishi mumkin  bo‘lgan suvenirlardan yana biri bu – BLOKNOTDIR. Ularga o‘z tovar belgingiz yoki kompaniyangiz brendini chop etish orqali siz mahsulot va xizmatlaringiz uchun arzon  reklamaga erishishingiz mumkin.',
    image: kundalikImg,
    url: '/product/kundalik',
  },
];

export default poligrafiya;
